export const initPopup = () => {
  const template = document.querySelector("[data-wm-popup-content-template]");

  if (!template) {
    return;
  }

  const popup = document.querySelector("[data-wm-modal-popup]");
  const popupContent = popup.querySelector("[data-wm-popup-content]");

  const showPopup = () => {
    popup.hidden = false;
  };

  const closePopup = () => {
    popup.hidden = true;
  };

  const setStaticContent = () => {
    popupContent.innerHTML = template.innerHTML;
  };

  const setCloseButton = () => {
    const closeButton = document.querySelector("[data-wm-close-popup-button]");
    closeButton.hidden = template.dataset.wmPopupHideCloseButton === "true";
    closeButton.addEventListener("click", closePopup, false);
  };

  const setExternalContent = () => {
    if (!window.wemove.page.preShareUrl) {
      return;
    }

    const externalContent = document.querySelector(
      "[data-wm-external-content]"
    );

    if (externalContent.length < 1) {
      return;
    }

    fetch(window.wemove.page.preShareUrl)
      .then((res) => res.text())
      .then((data) => {
        const thanksHtml = new DOMParser().parseFromString(data, "text/html");
        const shareButtonsHTML = thanksHtml.querySelector(
          "[data-wm-share-content]"
        )?.innerHTML;
        externalContent.innerHTML = shareButtonsHTML;
        externalContent.classList.remove("is-loading");

        window.wemove.triggerEvent("wm-popupContentLoaded");
      });
  };

  showPopup();
  setStaticContent();
  setExternalContent();
  setCloseButton();

  window.wemove.triggerEvent("wm-popupReady");
};
